import { NgModule } from "@angular/core";
import { SafeUrlPipe } from "./safe-url.pipe";
import { SizeGBPipe } from "./size-gb.pipe";
import { SizeMBPipe } from "./size-mb.pipe";
import { SoftwarePendingUpdatePipe } from "./software-pending-update.pipe";
import { SoftwareVersionPipe } from "./software-version.pipe";
import { TransformShortenSerialNumberPipe } from "./transform-shorten-serial-number.pipe";
import { SortPipe } from './sort.pipe';
import { KmMiPipe } from "./km-mi.pipe";

@NgModule({
  declarations: [SafeUrlPipe,SizeGBPipe,SizeMBPipe,SoftwarePendingUpdatePipe,SoftwareVersionPipe,TransformShortenSerialNumberPipe,SortPipe,KmMiPipe],
  imports: [],
  exports: [SafeUrlPipe,SizeGBPipe,SizeMBPipe,SoftwarePendingUpdatePipe,SoftwareVersionPipe,TransformShortenSerialNumberPipe,SortPipe,KmMiPipe]
})
export class CustomPipesModule {}